var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconlinkdin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4822 15.6219L24.039 8H22.4851L16.792 14.6178L12.2448 8H7L13.8763 18.0074L7 26H8.55391L14.5662 19.0114L19.3683 26H24.613L17.4818 15.6219H17.4822ZM15.354 18.0955L14.6572 17.099L9.11373 9.16972H11.5004L15.9738 15.569L16.6705 16.5655L22.4858 24.8834H20.0994L15.354 18.0959V18.0955Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconlinkdin);
export default __webpack_public_path__ + "static/media/iconlinkdin.170af7ca6b9da4a6b7ac30f0771643b6.svg";
export { ForwardRef as ReactComponent };